import { useQuery } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface ExplorerObjects {
  collectionData: any[];
  collectionSchema: {
    properties: Record<string, any>;
  };
  total?: number;
}

export function useExplorerObjects({
  container,
  size = 10,
  from = 0,
  search,
  esQuery,
}: {
  container: string;
  size?: number;
  from?: number;
  search?: string;
  esQuery?: string;
}) {
  const { keycloak } = useKeycloak();

  return useQuery({
    queryKey: ['container_objects', container, search, size, from, esQuery],
    queryFn: async (): Promise<ExplorerObjects> => {
      const response = await fetch(import.meta.env.VITE_EXPLORE_API_URL, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${keycloak.token}`,
        },
        method: 'POST',
        body: JSON.stringify({
          sourceAttributeId: `${container}-root_children`,
          container: container,
          size,
          from: from ? from + 1 : 0,
          searchStringNode: search,
          queryText: '',
          pitId: null,
          searchAfterArray: [],
          esQuery: esQuery,
          parentNode: null,
          viewFormat: 'table',
        }),
      });
      const data = await response.json();

      return data?.data?.nodes?.[0]?.data
        ? {
            collectionData: data?.data?.nodes?.[0]?.data?.collectionData,
            collectionSchema: data?.data?.nodes?.[0]?.data?.collectionSchema,
            total: data?.data?.total,
          }
        : {
            collectionData: [],
            collectionSchema: {},
            total: 0,
          };
    },
    keepPreviousData: true,
  });
}
